import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cashDescription'
})
export class CashDescriptionPipe implements PipeTransform {

  transform(description: string): string {
    let transformedString: string;

    if (description.includes("CASH TRANSFER")) {
       transformedString = "Cash Transfer";
    } else if (description.includes("RECEIPT")) {
       transformedString = "Cash Received from Customer";
    } else {
      transformedString = "Cash Paid to Customer";
    }

    return transformedString;
  }

}
